import Contact from "./components/Contact";
import Facts from "./components/Facts";
import Features from "./components/Features";
import Footer from "./components/Footer";
import Home from "./components/Home";
import Pricing from "./components/Pricing";
import Testimonials from "./components/Testimonials";

function App() {
  return (
    <>
    <Home/>
    <Features/>
    <Testimonials/>
    <Facts/>
    <Pricing/>
    <Contact/>
    <Footer/>
    </>
  );
}

export default App;
